import { updateGetters } from '@/store/extensions/update';
import { fetchGetters } from '@/store/extensions/fetch';

export default {
  ...updateGetters,
  ...fetchGetters,
};



// WEBPACK FOOTER //
// ./src/store/modules/app/getters.js